<template>
  <div>
    <div class="main-header d-none d-sm-none d-lg-flex">
      <div class="side-bar pe-4">
        <img
          src="~/assets/images/alfamart_logo_main.png"
          class="main-logo"
          alt="Alfamart"
        >
      </div>
      <div class="content-bar">
        <div class="ps-4">
          <p class="fw900 mb-0">
            {{ member?.storeCode ? member.storeCode : "-" }} -
            {{ member?.storeName ? formatText(member.storeName) : "-" }}
          </p>
          <div class="d-flex align-items-center">
            <div class="d-flex align-items-center">
              <img
                src="~/assets/images/Ic_Karyawan_Toko_APO.png"
                class="ic_karyawan me-1"
                alt="Karyawan Alfamart"
              >
              <span>{{ t("area-manager") }} :
                {{ member?.amName ? formatText(member.amName) : "-" }}</span>
            </div>
            <i class="bi bi-dot text-xlg mx-2" />
            <div class="d-flex align-items-center">
              <img
                src="~/assets/images/Ic_Karyawan_Toko_APO.png"
                class="ic_karyawan me-1"
                alt="Karyawan Alfamart"
              >
              <span>{{ t("area-coordinator") }} :
                {{ member?.acName ? formatText(member.acName) : "-" }}</span>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div
            v-if="member"
            class="text-center me-4"
          >
            <p class="text-xxlg fw600 mb-0">
              {{ time }} {{ timeZone }}
            </p>
            <span class="text-sm">{{ date }}</span>
          </div>
          <button
            class="btn btn-logout text-redgym-60 rounded-8 d-flex align-items-center text-sm fw700"
            @click="logout"
          >
            {{ t("logout") }} <i class="bi bi-box-arrow-right text-lg ms-2" />
          </button>
        </div>
      </div>
    </div>
    <div class="mobile-header d-lg-none">
      <button
        type="button"
        class="btn text-xxxlg"
        @click="toggleActive"
      >
        <i
          v-if="isActive"
          class="apo-chevron-left-box"
        />
        <i
          v-else
          class="apo-chevron-right-box"
        />
      </button>
      <img
        src="~/assets/images/alfamart_logo_main.png"
        class="main-logo"
        alt="Alfamart"
      >
    </div>
    <div
      class="sidebar-nav"
      :class="{ show: isActive }"
    >
      <div class="col-12 text-center p-12 mb-12">
        <p class="text-xxlg fw700 mb-0">
          {{ time }} {{ timeZone }}
        </p>
        <span class="text-sm fw500">{{ date }}</span>
      </div>
      <div class="card card-default p-3 rounded-12 mb-12">
        <p class="mb-2 fw800">
          {{ member?.storeCode ? member.storeCode : "-" }} -
          {{ member?.storeName ? formatText(member.storeName) : "-" }}
        </p>
        <div class="d-flex align-items-center">
          <img
            src="~/assets/images/Ic_Karyawan_Toko_APO.png"
            class="ic_karyawan me-1"
            alt="Karyawan Alfamart"
          >
          <span class="text-capitalize">{{ t("area-manager") }} :
            {{ member?.amName ? formatText(member.amName) : "-" }}</span>
        </div>
        <div class="d-flex align-items-center">
          <img
            src="~/assets/images/Ic_Karyawan_Toko_APO.png"
            class="ic_karyawan me-1"
            alt="Karyawan Alfamart"
          >
          <span class="text-capitalize">{{ t("area-coordinator") }} :
            {{ member?.acName ? formatText(member.acName) : "-" }}</span>
        </div>
      </div>
      <div class="mobile-menu">
        <ul class="list-unstyled">
          <li>
            <NuxtLink
              to="/dashboard-apo"
              @click="toggleActive"
            >
              <div class="d-flex align-items-center">
                <i class="apo-pie-cart text-xxlg me-1" />
                <span class="text-sm fw700">{{ t("dashboard-apo") }}</span>
              </div>
            </NuxtLink>
          </li>
          <li>
            <NuxtLink
              to="/monitoring-performance"
              @click="toggleActive"
            >
              <div class="d-flex align-items-center">
                <i class="apo-data-bar text-xxlg me-1" />
                <span class="text-sm fw700">{{
                  t("monitoring-performance")
                }}</span>
              </div>
            </NuxtLink>
          </li>
          <li>
            <div
              class="d-flex align-items-center expandable-menu"
              :class="{
                'router-link-active': isSubmenuMonitoringAnalyticsSelected,
              }"
              style="cursor: pointer"
              @click="openCloseSubmenuMonitoringAnalytics"
            >
              <i class="apo-dashboard-analytic text-xxlg me-1" />
              <span class="text-sm fw700 me-auto">Monitoring Analytic</span>
              <i
                v-if="isActive"
                class="apo-chevron-up text-xxlg chevron-transition fw600"
                :class="{ 'rotate-chevron': isSubmenuMonitoringAnalyticsOpen }"
              />
            </div>
            <ul
              v-if="isSubmenuMonitoringAnalyticsOpen"
              class="list-unstyled"
            >
              <li
                v-for="(submenu, index) in monitoringAnalyticSubMenus"
                :key="index"
                @click="toggleActive"
              >
                <NuxtLink :to="submenu.to">
                  <div class="d-flex align-items-center ps-4">
                    <span class="text-sm fw700"> {{ submenu.label }} </span>
                  </div>
                </NuxtLink>
              </li>
            </ul>
          </li>
          <li>
            <div
              v-if="showMenu"
              class="d-flex align-items-center expandable-menu"
              :class="{
                'router-link-active': isSubmenuTrackingSelected,
              }"
              style="cursor: pointer"
              @click="openCloseSubmenuTracking"
            >
              <i class="apo-apo-tracking text-xxlg me-1" />
              <span class="text-sm fw700 me-auto">Tracking</span>
              <i
                v-if="isActive"
                class="apo-chevron-up text-xxlg chevron-transition fw600"
                :class="{ 'rotate-chevron': isSubmenuTrackingOpen }"
              />
            </div>
            <ul
              v-if="isSubmenuTrackingOpen"
              class="list-unstyled"
            >
              <li
                v-for="(submenu, index) in trackingMenus"
                :key="index"
                @click="toggleActive"
              >
                <NuxtLink :to="submenu.to">
                  <div class="d-flex align-items-center ps-4">
                    <span class="text-sm fw700"> {{ submenu.label }} </span>
                  </div>
                </NuxtLink>
              </li>
            </ul>
          </li>
          <!-- Role Management menu is temporarily disabled.
          <li v-if="showMenu">
            <NuxtLink
              to="/role-management"
              @click="toggleActive"
            >
              <div class="d-flex align-items-center">
                <i class="apo-apo-role-management text-xxlg me-1" />
                <span class="text-sm fw700">Manage Role</span>
              </div>
            </NuxtLink>
          </li>
          -->
          <li>
            <NuxtLink
              to="/claim-operational-sapa"
              :class="{ 'router-link-active': isClaimMenuActive }"
              @click="toggleActive"
            >
              <div class="d-flex align-items-center">
                <img
                  v-if="isClaimMenuActive"
                  :src="IcStarActive"
                  class="apo-data-bar text-xxlg ms-1 me-2"
                >
                <img
                  v-else
                  :src="IcStarInactive"
                  class="apo-data-bar text-xxlg ms-1 me-2"
                >
                <span class="text-sm fw700">{{ t('klaim-operasional-sapa') }}</span>
              </div>
            </NuxtLink>
          </li>
          <li>
            <NuxtLink
              to="/monitoring-tag-i"
              @click="toggleActive"
            >
              <div class="d-flex align-items-center">
                <img
                  :src="MonitoringTagIcon"
                  class="monitoring-tag-icon ms-1 me-2"
                  alt=""
                >
                <span class="text-sm fw700">Monitoring Tag-I</span>
              </div>
            </NuxtLink>
          </li>
        </ul>
      </div>
      <div class="fixed-action-bottom">
        <NuxtLink
          to="/login"
          class="btn btn-logout text-redgym-60 text-sm fw700 rounded-8 d-flex align-items-center justify-content-center py-2 px-3 w-100"
          @click="logout"
        >
          {{ t("logout") }} <i class="bi bi-box-arrow-right text-lg ms-2" />
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from '~/composables/useI18n'
import { useMember } from '~/composables/useMember'
import IcStarActive from '~/assets/images/ic_star_active.svg?url'
import IcStarInactive from '~/assets/images/ic_star_inactive.svg?url'
import MonitoringTagIcon from '~/assets/images/ic_monitoring_tag.svg?url'

const route = useRoute()
const isActive = ref(false)
const isSubmenuMonitoringAnalyticsOpen = ref(false)

const isSubmenuTrackingOpen = ref(false)

const { logout } = useAuth()
const { fetchMember, member } = useMember()
const { formatText } = useTextFormatter()
const { t } = useI18n()

// Function to toggle the sidebar visibility
function toggleActive () {
    isActive.value = !isActive.value
}

const monitoringAnalyticSubMenus = [
    {
        label: 'GLI - New SAPA Performance',
        to: '/monitoring-analytic/gli-new-sapa-performance',
    },
    {
        label: 'Refund Alfagift Today',
        to: '/monitoring-analytic/refund-alfagift',
    },
    {
        label: 'Alfagift Late Reason Daily',
        to: '/monitoring-analytic/alfagift-late-reason',
    },
    {
        label: 'Alfagift APO ASO Store Daily',
        to: '/monitoring-analytic/alfagift-apo-aso',
    },
    {
        label: 'GLI - SAPA Pending Order H-4',
        to: '/monitoring-analytic/gli-sapa-pending-order',
    },
    {
        label: 'Alfagift Pengiriman Tunda Daily',
        to: '/monitoring-analytic/alfagift-pengiriman-tunda',
    },
    {
        label: 'Alfagift Lapor Equipment Daily',
        to: '/monitoring-analytic/alfagift-lapor-equipment',
    },
]

const isSubmenuMonitoringAnalyticsSelected = computed(() => {
    return monitoringAnalyticSubMenus.some(menu =>
        route.path.startsWith(menu.to),
    )
})

const isClaimMenuActive = computed(() => {
    return route.path.startsWith('/claim-operational-sapa')
})

// Function to open or close the submenu for Monitoring Analytics
function openCloseSubmenuMonitoringAnalytics () {
    if (isActive.value) {
        isSubmenuMonitoringAnalyticsOpen.value =
      !isSubmenuMonitoringAnalyticsOpen.value
    }
}

const trackingMenus = [
    {
        label: 'Realtime Tracking',
        to: '/tracking/realtime-tracking',
    },
    {
        label: 'Tracking Report',
        to: '/tracking/tracking-report',
    },
    {
        label: 'Monitoring Position',
        to: '/tracking/monitoring-position',
    },
]

const isSubmenuTrackingSelected = computed(() => {
    return trackingMenus.some(menu => route.path.startsWith(menu.to))
})

function openCloseSubmenuTracking () {
    if (isActive.value) {
        isSubmenuTrackingOpen.value = !isSubmenuTrackingOpen.value
    }
}

await fetchMember()

const timeZone = computed(() => member.value?.timeZone || 'WIB')
const { time, date } = useTime(timeZone.value)

const showMenu = computed(() => {
    const today = new Date()
    const releaseDate = new Date('2025-12-22T04:00:00')
    return today >= releaseDate
})
</script>

<style scoped lang="scss">
.main-header {
  padding: 17px 24px;
  display: flex;
  align-items: center;
  border-bottom: solid 1px #d8d8d8;
  background-color: $neutral-10;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 9;
  .side-bar {
    flex: 0 0 196px;
    border-right: solid 1px #d8d8d8;
    .main-logo {
      height: 32px;
    }
  }
  .content-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .ic_karyawan {
      height: 16px;
    }
    .btn-logout {
      border: solid 1px $neutral-50;
      padding-top: 11px;
      padding-bottom: 11px;
    }
  }
}
.mobile-header {
  display: flex;
  background-color: $neutral-10;
  padding: 16px;
  border-bottom: solid 1px $neutral-50;
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  .btn {
    position: absolute;
    color: $neutral-70;
    padding: 0;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
  }
  .main-logo {
    height: 32px;
    margin: auto;
  }
}
.sidebar-nav {
  position: fixed;
  background-color: $neutral-10;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  transform: translateX(-100%);
  transition-duration: 0.3s;
  height: calc(100% - 64px);
  margin-top: 64px;
  padding: 12px 16px;
  &.show {
    transform: none;
    overflow-y: scroll;
    padding-bottom: 100px;
  }
  .card-default {
    .ic_karyawan {
      height: 16px;
    }
  }
  .mobile-menu {
    margin-left: -16px;
    margin-right: -16px;
    ul {
      li {
        a,
        .expandable-menu {
          padding: 12px 24px;
          display: block;
          text-decoration: none;
          color: $dark;
          &.router-link-active {
            background-color: $primary;
            color: $neutral-10;

            .monitoring-tag-icon {
              filter: brightness(0) invert(1);
            }
          }
        }
        ul {
          li {
            a {
              &.router-link-active {
                background: none;
                color: $primary;
              }
            }
          }
        }
      }
    }
  }
  .fixed-action-bottom {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 12px 16px;
    background-color: $neutral-10;
    .btn-logout {
      border: solid 1px $neutral-50;
    }
  }
}
.monitoring-tag-icon {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
}

.apo-chevron-up:before {
  font-weight: 600;
}
.chevron-transition {
  display: inline-block;
  transition: transform 0.3s ease;
  transform: rotate(180deg);
}

.rotate-chevron {
  transform: rotate(0deg);
}
</style>
